import axios from 'axios';
import { storageAvailable } from './utils';

export default ({
  triggerTarget = '.js-load-more',
  containerTarget = '.js-load-more-container',
} = {}) => {
  const trigger = document.querySelector(triggerTarget);

  let url = '/';
  const params = {
    search: null, // search
    destination: null,
    theme: null,
    paged: 2,
  };

  let totalItems = 0;
  let perPage = 20;
  let pages = [];

  let isFetching = false;
  let fetchMoreClicked = false;
  let prefetchedItems = null;

  let currentButton = null;

  const loadingIcon = document.createElement('div');
  loadingIcon.innerHTML = '<div></div><div></div><div></div>';
  loadingIcon.classList.add('o-bouncing-loader');

  const hasSessionStorage = storageAvailable('sessionStorage');

  function hideLoadMore() {
    trigger.classList.add('u-hidden');
  }

  function showLoadingIcon(button) {
    if (button) {
      currentButton = button;

      if (
        currentButton.nextElementSibling &&
        currentButton.nextElementSibling.classList.contains('o-bouncing-loader')
      ) {
        loadingIcon.style.display = 'flex';
      } else {
        currentButton.insertAdjacentElement('afterend', loadingIcon);
      }

      currentButton.style.display = 'none';

      currentButton.disabled = true;
    }
  }

  function hideLoadingIcon() {
    if (currentButton) {
      currentButton.disabled = false;
      currentButton.style.display = 'flex';

      loadingIcon.style.display = 'none';

      currentButton = null;
    }
  }

  function updatePage() {
    if (params.paged >= pages[pages.length - 1]) {
      hideLoadMore();
    }

    // Get browser to store latest page state so that new listings appear if ever navigated back to.
    window.location.hash = `p-${params.paged}`;
    window.history.replaceState(null, null, `#p-${params.paged}`);
    window.dispatchEvent(new HashChangeEvent('hashchange'));

    params.paged += 1;
  }

  function resetData(update = true) {
    isFetching = false;
    fetchMoreClicked = false;

    if (update) {
      updatePage();
    }

    setTimeout(() => hideLoadingIcon(), 0);
  }

  function renderItems(items, storeInSession = true) {
    const container = document.querySelector(containerTarget);

    if (container && items.indexOf('<div') > -1) {
      container.innerHTML += items;

      if (storeInSession && hasSessionStorage) {
        let results = {};

        const storedResults = JSON.parse(
          sessionStorage.getItem('loadMoreResults')
        );

        if (storedResults) {
          results = storedResults;
        }

        results[params.paged] = items;

        sessionStorage.setItem('loadMoreResults', JSON.stringify(results));
      }
    }

    resetData(storeInSession);

    if (prefetchedItems) {
      prefetchedItems = null;
    }
  }

  function prefetchMore() {
    if (!isFetching && !prefetchedItems) {
      console.log(
        `prefetch more articles from ${url} with ${params.destination} ${params.theme}`
      ); // eslint-disable-line

      isFetching = true;

      axios.get(url, { params }).then((res) => {
        prefetchedItems = res.data;

        if (fetchMoreClicked) {
          renderItems(prefetchedItems);
        }
      });
    }
  }

  function fetchMore() {
    if (prefetchedItems) {
      console.log(`render prefetched items`); // eslint-disable-line

      renderItems(prefetchedItems);
    } else if (!isFetching) {
      console.log(
        `fetch more articles from ${url} with ${params.destination} ${params.theme}`
      ); // eslint-disable-line

      isFetching = true;

      axios.get(url, { params }).then((res) => {
        renderItems(res.data);
      });
    }
  }

  function handleLoadMoreClick(e) {
    fetchMoreClicked = true;

    e.preventDefault();
    e.target.blur();

    if (!currentButton) {
      showLoadingIcon(e.target);

      fetchMore(e.target.dataset.url);
    }
  }

  function handleLoadMoreHover(e) {
    prefetchMore(e.target.dataset.url);
  }

  function setupData(data) {
    url = data.url;

    if (data.total) {
      totalItems = data.total;
    }

    Object.keys(params).forEach((k) => {
      if (data[k]) {
        params[k] = data[k];
      }
    });

    if (data.search) {
      params.s = data.search;
    }

    if (data.perPage) {
      perPage = data.perPage;
    }

    const start = 1;
    const end = Math.ceil(totalItems / perPage);

    pages = [];

    for (let i = start; i <= end; i += 1) {
      pages.push(i);
    }

    if (
      window.location.hash.indexOf('p-') > -1 &&
      hasSessionStorage &&
      sessionStorage.getItem('loadMoreResults')
    ) {
      const stored = JSON.parse(sessionStorage.getItem('loadMoreResults'));

      const hashPage = Number(window.location.hash.split('-')[1]);

      if (hashPage > 0) {
        Object.keys(stored).forEach((page) => {
          if (page <= hashPage) {
            renderItems(stored[page], false);
          }
        });

        params.paged = hashPage + 1;

        if (params.paged >= pages[pages.length - 1]) {
          hideLoadMore();
        }
      }
    }
  }

  if (trigger) {
    setupData(trigger.dataset);

    trigger.addEventListener('mouseover', handleLoadMoreHover);
    trigger.addEventListener('click', handleLoadMoreClick);
  }
};
